import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isFunction } from '@pct-ts/typeguard';

@Pipe({
  name: 'isFunction',
})
export class IsFunctionPipe implements PipeTransform {
  transform(value: unknown): value is (...args: any) => unknown {
    return isFunction(value);
  }
}
